package org.example.zone360.pages.widgets.helper

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.icons.fa.FaInfo
import com.varabyte.kobweb.silk.components.icons.fa.FaXmark
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.theme.SitePalette
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.Constants
import org.example.zone360.utils.MarkdownRenderer
import org.example.zone360.utils.injectMarkdownStyles
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
private fun WidgetInfoPopup(
    title: String,
    text: String,
    breakpoint: Breakpoint,
    sitePalette: SitePalette,
    onClose: () -> Unit
) {
    injectMarkdownStyles()

    var isCloseHovered by remember { mutableStateOf(false) }

    Box(
        modifier = Modifier
            .width(if (breakpoint < Breakpoint.MD) 90.percent else 500.px)
            .position(Position.Fixed)
            .zIndex(999999)
            .top(50.percent)
            .left(50.percent)
            .transform { translate((-50).percent, (-50).percent) },
        contentAlignment = Alignment.Center,
    ) {
        Box(
            modifier = Modifier
                .width(90.percent)
                .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                .borderRadius(14.px)
                .styleModifier {
                    property("max-height", "100vh")
                    property("box-sizing", "border-box")
                    property("box-shadow", "0 18px 45px rgba(0,0,0,.18)")
                    property("border", "1px solid #F1F1F1")
                }
                .onClick { it.stopPropagation() },
        ) {
            Column(modifier = Modifier.fillMaxWidth()) {

                // Header
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(50.px)
                        .styleModifier {
                            property(
                                "background",
                                """
        linear-gradient(
            135deg,
            #FB6F2A 0%,
            #FD7A36 45%,
            #FF925A 100%
        )
        """.trimIndent().replace("\n", "")
                            )
                        }
                        .borderRadius(topLeft = 14.px, topRight = 14.px),
                    contentAlignment = Alignment.Center
                ) {
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(leftRight = 10.px),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.SpaceBetween
                    ) {

                        Row(
                            verticalAlignment = Alignment.CenterVertically
                        ) {

                            // Info Circle
                            Box(
                                modifier = Modifier
                                    .size(25.px)
                                    .flexShrink(0)
                                    .backgroundColor(Color.rgba(255, 255, 255, .18f))
                                    .borderRadius(100.px),
                                contentAlignment = Alignment.Center
                            ) {
                                FaInfo(
                                    modifier = Modifier.color(Colors.White),
                                    size = IconSize.SM
                                )
                            }

                            FieldTitleTextNormalSimple(
                                text = title,
                                fontSize = if (breakpoint < Breakpoint.MD) 15.px else 18.px,
                                fontWeight = 700,
                                marginLeft = 5.px,
                                color = Colors.White,
                            )
                        }

                        Box(
                            modifier = Modifier
                                .size(20.px)
                                .borderRadius(100.px)
                                .cursor(Cursor.Pointer)
                                .onMouseEnter { isCloseHovered = true }
                                .onMouseLeave { isCloseHovered = false }
                                .backgroundColor(
                                    if (isCloseHovered)
                                        Color.rgba(255, 255, 255, .15f)
                                    else
                                        Colors.Transparent
                                )
                                .onClick { onClose() },
                            contentAlignment = Alignment.Center
                        ) {
                            FaXmark(
                                modifier = Modifier.color(Colors.White),
                                size = IconSize.XL
                            )
                        }
                    }
                }

                // Divider
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(1.px)
                        .backgroundColor(Color.rgb(235, 235, 235))
                )

                // Body
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(20.px)
                ) {
                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .overflow(Overflow.Auto)
                            .maxHeight(500.px)
                            .padding(leftRight = 10.px)

                    ) {

                        MarkdownRenderer(
                            text = text,
                            whiteSpace = WhiteSpace.PreWrap,
                            fontSize = 15.px,
                            color = Color.rgb(55, 55, 55)
                        )
                    }
                }
            }
        }
    }
}


@Composable
fun WidgetTooltipIcon(
    tooltipText: String,
    tooltipTitle: String = "Info",
    modifier: Modifier = Modifier
) {
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    var isPopupOpen by remember { mutableStateOf(false) }

    Box(modifier = modifier) {
        Box(
            modifier = Modifier
                .width(18.px)
                .height(18.px)
                .flexShrink(0)
                .cursor(Cursor.Pointer)
                .backgroundColor(Colors.LightGray)
                .borderRadius(100.px)
                .onClick { isPopupOpen = true },
            contentAlignment = Alignment.Center
        ) {
            FaInfo(
                modifier = Modifier.color(Colors.White),
                size = IconSize.XXS
            )
        }
    }

    if (isPopupOpen) {
        WidgetInfoPopup(
            title = tooltipTitle,
            text = tooltipText,
            breakpoint = breakpoint,
            sitePalette = sitePalette,
            onClose = { isPopupOpen = false }
        )
    }
}